var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.83a6.5 6.5 0 0 0-6.5 6.5c0 2.52 1.64 4.98 3.48 6.92A24.36 24.36 0 0 0 12 19.94a23.17 23.17 0 0 0 3.02-2.69c1.84-1.94 3.48-4.4 3.48-6.92a6.5 6.5 0 0 0-6.5-6.5Zm0 17.34-.56.83-.02-.02a9.59 9.59 0 0 1-.33-.23 26.35 26.35 0 0 1-3.57-3.13C5.61 16.6 3.5 13.66 3.5 10.34a8.5 8.5 0 1 1 17 0c0 3.32-2.1 6.27-4.02 8.3a26.35 26.35 0 0 1-3.9 3.35l-.02.01-.56-.82Zm0 0 .55.83-.55.37-.56-.37.56-.83Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.83a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-3.5 1.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.9059ecef2de32521d31a9be412039f7b.svg";
export { ForwardRef as ReactComponent };